import { Card, CardContent, Typography, Button } from "@mui/material"
import { motion } from "framer-motion"
import useTranslationSharie from "../hooks/Language/useTranslation"

export default function WisdomDrop({ quote, question, onReflect }) {
  const t = useTranslationSharie()

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}
    >
      <Card
        elevation={8}
        sx={{
          maxWidth: 400,
          background: "linear-gradient(135deg, #1976d2 20%, #9c27b0 100%)",
          color: "text.primary",
          borderRadius: "0.8rem",
          textAlign: "center",
          padding: 2,
        }}
      >
        <CardContent>
          <Typography variant='h6' sx={{ fontWeight: "bold", mb: 2 }}>
            ✨ {t("Daily Wisdom")}
          </Typography>
          <Typography
            variant='body1'
            sx={{
              fontSize: "1.2rem",
              fontStyle: "italic",
              mb: 2,
            }}
          >
            "{quote}"
          </Typography>
          <Typography
            variant='body2'
            sx={{
              fontSize: "1rem",
              mb: 3,
            }}
          >
            {question}
          </Typography>
          {onReflect && (
            <Button
              variant='contained'
              color='secondary'
              onClick={onReflect}
              sx={{
                backgroundColor: "background.paper",
                color: "#1976d2",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#f0f0f0",
                },
              }}
            >
              {t("Reflect Now")}
            </Button>
          )}
        </CardContent>
      </Card>
    </motion.div>
  )
}
